module.exports = __webpack_public_path__ + "static/background-4898246bb825954b60f858896af43c7f.jpg";